import { motion } from 'framer-motion';

const Blog = () => {
  const navigate = window.REACT_APP_NAVIGATE;

  const beliefs = [
    {
      title: 'The Bible',
      description: 'We believe in the divine inspiration and authority of the Holy Scriptures. That the Bible is infallible in its declaration, final in its authority, all-sufficient in its provisions and comprehensive in its sufficiency (2 Timothy 3:16; 2 Peter 1:21).',
      image: 'https://www.oxfordpiwc.com/wp-content/uploads/2025/05/holy-bible-open-on-a-stand-inside-a-church-symbolizing-faith-and-spirituality.-372326-1024x683.jpg',
    },
    {
      title: 'The One True God',
      description: 'We believe in the existence of the One True God, Elohim, Maker of the whole universe; indefinable, but revealed as Triune Godhead – Father, Son and Holy Spirit – one in nature, essence and attributes; Omnipotent, Omniscient and Omnipresent (Genesis 1:1; Matthew 3:16-17; 2 Corinthians 13:14; Matthew 28:19; Genesis 1:26)',
      image: 'https://www.oxfordpiwc.com/wp-content/uploads/2025/05/a-breathtaking-view-of-the-milky-way-across-a-starry-night-sky-ideal-for-backgrounds.-176851-scaled.jpg',
    },
    {
      title: 'Man\'s Depraved Nature',
      description: 'We believe that: "all men have sinned and come short of the glory of God;" are subject to eternal punishment; and need repentance and regeneration (Genesis 3:1-19; Isaiah 53:6)',
      image: 'https://www.oxfordpiwc.com/wp-content/uploads/2025/05/elegant-womans-hand-holding-a-red-apple-against-a-dark-background-symbolizing-temptation.-29254086-scaled.jpg',
    },
  ];

  return (
    <section id="blog" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-gray-500 text-sm font-semibold tracking-wider uppercase mb-4">
            All About Jesus
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6 font-['Playfair_Display']">
            What We Believe
          </h2>
          <p className="text-base text-gray-600 max-w-3xl mx-auto leading-relaxed">
            These are the Tenets of the church.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {beliefs.map((belief, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-gray-50 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow border border-gray-200"
            >
              <div className="relative h-64">
                <img
                  src={belief.image}
                  alt={belief.title}
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-black mb-4">
                  {belief.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {belief.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mt-12"
        >
          <button 
            onClick={() => navigate('/beliefs')}
            className="bg-black hover:bg-gray-900 text-white px-8 py-3 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            Learn More
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Blog;
